import { Link } from "react-router-dom";

export const ProductCard = ({ product }) => (
  <Link
    to={`/product/${product.id}`}
    data-testid={`product-card-${product.id}`}
    className="group border border-border bg-card hover:-translate-y-1 transition-transform duration-200 block"
  >
    <div className="relative aspect-[4/5] overflow-hidden border-b border-border bg-muted">
      <img
        src={product.image}
        alt={product.name}
        loading="lazy"
        decoding="async"
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
      />
      <span className="absolute top-0 left-0 bg-black text-white font-mono text-[10px] uppercase tracking-widest px-2 py-1">
        {product.type === "print" ? "Print" : "Tee"}
      </span>
      <span className="absolute top-0 right-0 bg-primary text-primary-foreground font-mono text-[10px] uppercase tracking-widest px-2 py-1">
        {product.category}
      </span>
    </div>
    <div className="p-4 flex items-center justify-between">
      <div className="min-w-0">
        <h3 className="font-outfit font-bold text-sm md:text-base uppercase truncate">{product.name}</h3>
        <p className="font-mono text-xs text-muted-foreground mt-0.5">{product.type === "print" ? "We print & mail" : "Heavyweight cotton"}</p>
      </div>
      <span className="font-anton text-xl ml-3 shrink-0">${product.price.toFixed(0)}</span>
    </div>
  </Link>
);
